module.exports = __webpack_public_path__ + "static/img/cart.1e46d6ce.svg";